  <template>
    <div>
      <h6 class="text-center sticky-top bg-white py-3 m-0">服務條款 Terms of Use</h6>
      <div class="text-muted small px-3">
        <b>條款及條件的確認與接受</b>
        <p>歡迎使用博祥國際股份有限公司（以下簡稱「本公司」）提供的網路服務，包括但不限於 LINE 機器人「小美祕書」（以下簡稱「本服務」）。在使用本服務之前，請您詳細閱讀並同意以下條款及條件。當您進行LINE帳號登入並開始使用本服務時，即表示您已經閱讀、理解並同意遵守本條款及條件。如果您不同意任何條款或條件，請停止使用本服務。</p>

        <b>條款的修訂</b>
        <p>本公司有權在任何時間修改或更改本條款及條件，修訂後的內容將刊登於相關網頁上。我們將不會個別通知每位使用者。建議使用者定期檢查條款的變動。若您在條款修訂後繼續使用本服務，即視為您已經閱讀、理解並同意接受修訂後的條款。</p>

        <b>LINE帳號</b>
        <ol>
          <li>用戶必須先以中華民國境內手機號碼註冊LINE帳號，才能登入本服務。LINE帳號之管理及其他使用，應適用<a target="_blank" rel="noopener" href="https://terms.line.me/line_terms?lang=zh-Hant">LY通用服務條款</a>。</li>
          <li>用戶瞭解且同意，本服務需要使用LINE帳號並於LINE作業環境中使用。如果用戶因任何原因無法使用LINE帳號或LINE作業環境，將無法使用本服務。利用LINE帳號登入本服務所進行的一切行為，均視為註冊該LINE帳號之用戶本人的行為。</li>
          <li>自用戶不論任何原因導致其LINE帳號遭刪除或遭停止使用LINE相關服務時起，用戶使用本服務的所有權利將同時終止，用戶於本服務的使用紀錄亦將隨同消滅，用戶不得異議或請求任何賠（補）償。即便用戶不慎刪除LINE帳號，原有LINE帳號的使用紀錄亦無法回復，敬請留意。</li>
        </ol>

        <b>身份辨識與認證</b>
        <p>本服務採用LINE帳號登入作為身份辨識與認證的手段。您同意提供準確、最新且完整的LINE帳號登入資訊。如發現提供的資訊不正確或不完整，本公司有權停止提供本服務。</p>

        <b>訂閱制服務</b>
        <ol>
          <li><b>計費方式：</b>小美祕書採用訂閱制服務，提供季繳以及年繳的選擇。</li>
          <li><b>提早停止自動扣繳：</b>若提早停止自動扣繳，服務將持續到期間結束為止，不會退費。</li>
          <!-- <li><b>重新訂閱：</b>若需繼續使用服務，需要重新訂閱，恢復自動扣繳。</li> -->
        </ol>

        <b>隱私保護</b>
        <p>您的隱私對本公司極為重要。請閱讀我們的隱私政策，了解我們如何收集、使用和保護您的個人資訊。</p>

        <b>服務中斷</b>
        <p>本服務可能因網路、技術故障等原因暫時中斷，可能導致使用不便或資料損失。使用者應自行採取保護措施，本公司對因使用或無法使用本服務所造成的損失不承擔任何賠償責任。</p>

        <b>免責聲明</b>
        <p>本公司不對您因使用本服務而可能遭受的任何直接、間接、附隨或特別損害負責。使用者需自行承擔使用本服務的風險。</p>

        <b>法律適用與爭議解決</b>
        <p>本條款及條件受台灣法律管轄，任何爭議應依照台灣法律解決。使用者與本公司一致同意，如有爭議，應提交至台灣台北地方法院解決。</p>
      </div>
    </div>
    <div class="text-muted text-center">---</div>
    <div id="privacy">
      <h6 class="text-center sticky-top bg-white py-3 m-0">隱私權政策 Privacy Policy</h6>
      <div class="text-muted small px-3">
        <p>生效日期：2024年1月1日</p>
        <p>感謝您使用博祥國際股份有限公司（以下簡稱「本公司」）提供的網路服務，包括但不限於 LINE 機器人「小美祕書」（以下簡稱「本服務」）。為了保障您的隱私權益，請您詳細閱讀以下隱私權政策。當您使用LINE帳號登入並開始使用本服務時，即表示您已經閱讀、理解並同意本隱私權政策的內容。</p>

        <b>一、收集的資訊類型</b>
        <ol>
          <li><b>LINE帳號登入資訊：</b>我們使用LINE帳號登入作為身份辨識與認證的方式，收集您的LINE帳號登入相關資訊。</li>
          <li><b>識別資訊：</b>當您使用本服務時，我們可能收集您的識別資訊，如姓名、聯絡地址、電話號碼、電子郵件地址等。</li>
          <li><b>使用者資訊：</b>為了提供更好的服務，我們可能收集有關您使用本服務的相關資訊，包括但不限於使用紀錄、操作行為等。</li>
          <li><b>其他相關資訊：</b>為了改善本服務，我們可能從第三方取得其他相關資訊，例如 LINE 平台提供的資訊。</li>
        </ol>
        
        <b>二、資訊使用目的</b>
        <ol>
          <li><b>提供本服務：</b>使用收集的LINE帳號登入資訊進行身份辨識，以確保您正確使用本服務。</li>
          <li><b>個人化服務：</b>根據您的識別資訊和使用者資訊，提供個人化的服務與推薦。</li>
          <li><b>服務改進：</b>分析使用者資訊，以了解和改進本服務的功能和性能。</li>
          <li><b>法定義務：</b>遵守適用法律法規，履行法定義務，包括但不限於身份認證和記錄保存。</li>
          <li><b>提供客戶支援：</b>回應您的查詢、疑慮或投訴，提供客戶支援服務。</li>
        </ol>
        
        <b>三、資訊分享與披露</b>
        <ol>
          <li>本公司承諾不會將您的個人資訊出售、交換、出租或提供給第三方，除非取得您的明確同意或法律規定。</li>
          <li>在下列情況下，本公司可能分享您的資訊：
            <ul class="ps-3">
              <li><b>經您同意：</b>獲得您的明確同意後，分享您的資訊。</li>
              <li><b>法定要求：</b>符合適用法律法規、司法機關或其他政府機構的法定要求。</li>
              <li><b>保護權益：</b>為保護本公司、使用者或社會公眾的權益、財產或安全。</li>
              <li><b>企業交易：</b>如進行合併、收購或出售資產，可能需要分享您的資訊。</li>
            </ul>
          </li>
        </ol>
        
        <b>四、資訊存儲與安全</b>
        <ol>
          <li>本公司將採取合理的技術手段，保障您的資訊安全，防止未經授權的存取、使用或洩漏。</li>
          <li>您的資訊將儲存於安全伺服器，僅授權人員可存取。我們將盡力保護您的個人資訊安全。</li>
        </ol>
        
        <b>五、使用者權利</b>
        <ol>
          <li>您有權查詢、更正、刪除您的個人資訊。您可以透過聯絡本公司指定的聯絡方式行使這些權利。</li>
          <li>若您希望停止使用本服務或刪除您的資訊，亦可透過會員資訊頁面或聯絡本公司指定的聯絡方式提出您的請求。我們將盡快回應您的請求並進行相應處理。</li>
        </ol>
        
        <b>六、未成年人保護</b>
        <p>未滿十八歲之未成年人使用本服務應取得法定代理人同意。我們建議父母或監護人教育未成年人保護個人隱私資訊。</p>
        
        <b>七、隱私權政策的修改</b>
        <p>本公司有權隨時修改本隱私權政策，修改後的內容將於相關網頁上公告。我們建議您定期查閱本隱私權政策，以瞭解最新資訊。</p>
        <p>謝謝您閱讀本隱私權政策。</p>
      </div>
    </div>
  </template>
  
  <script>
  // import { ref } from 'vue';

  export default {
    name: 'termsPrivacy',
    props: ['type'],
    data() {
      return {
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  // #terms .sticky-top {
  //   top: 68px!important;
  // }
  </style>
  
  